export const FETCH_TRANSPORT_QUOTATIONS_SUCCESS = 'fetch_transport_quotations_success'
export const ADD_TRANSPORT_QUOTATION_SUCCESS = 'add_transport_quotation_success'
export const FETCH_TRANSPORT_QUOTATION_DETAILS_SUCCESS = 'fetch_transport_quotation_details_success'
export const UPDATE_TRANSPORT_QUOTATION_SUCCESS = 'update_transport_quotation_success'
